var registEasyLoginDialog = {
    dialogBoxDom: document.querySelector('#regist-login-dialog'),
    maskDom: document.querySelector('#regist-login-dialog').querySelector('.mask'),
    dialogDom: document.querySelector('#regist-login-dialog').querySelector('.container'),
    vueObject: null,

    vueExp: function () {
        var dialogObj = this;
        this.vueObject = new Vue({
                el: "#vue-regist-login-dialog",
                data: {
                    // 登录表单
                    loginForm: {
                        title: '请登录',
                        formList: {
                            userName: {
                                lebal: '账号',
                                placeholder: '请输入您的账号',
                                value: '',
                                type: 'text',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '账号输入错误',
                                errorTextEmpty: '请输入账号',
                            },
                            password: {
                                lebal: '密码',
                                placeholder: '请输入密码',
                                value: '',
                                type: 'password',
                                isShowError: false,
                                isRequired: true,
                                reg: '',
                                errorText: '',
                                errorTextContent: '密码输入错误',
                                errorTextEmpty: '请输入密码',
                            }
                        },
                        subBtnText: '登录',
                        subBtnDisabled: false
                    },
                    form: {
                        title: ''
                    },
                    list: [],
                    keyword: '',
                    userInfo: {},
                    loginTimeout: null
                },
                created: function () {
                    this.form = this.loginForm;
                },
                methods: {

                    // 取消
                    cancel: function () {
                        msg.dialog('完成企业认证即可抽奖! 确定放弃吗？', function () {
                            dialogObj.hideDialog();
                        })
                    },

                    // 登录
                    login: function () {
                        if (!this.verifyForm()) {
                            console.log('验证不通过');
                            return;
                        }

                        var userName = this.loginForm.formList.userName.value;
                        var password = this.loginForm.formList.password.value;

                        this.loginForm.subBtnDisabled = true;
                        this.loginForm.subBtnText = '登录中...';
                        var _this = this;
                        memberCommonAPI.login(userName,password,'',function (data){
                                if (data.errCode === 0){
                                    data = data.data;
                                    try {
                                        // gio 埋码
                                        var giouserinfo = data.info;
                                        var gioParams = {
                                            phone_ppl: common.mobileGioEncryption(giouserinfo.mobile),
                                        }

                                        gio('people.set',gioParams);
                                        //cookie中设置一个用户手机
                                        common.setCookie('dell_userName', giouserinfo.name|| '', 5);
                                        common.setCookie('dell_userMobile', common.mobileEncryption(giouserinfo.mobile), 5);
                                        common.setCookie('Activity_MOBILE', 'MOBILE'+giouserinfo.mobile+'number', 365);
                                        gio('track', 'loginSuccess', {'user_Id': data.memberId, 'phoneNumber': common.mobileGioEncryption(giouserinfo.mobile),'loginType': '账号'})

                                        userRecode({behaviorType: '登录', behaviorResult: '登录成功'});
                                        msg.toast('登录成功');
                                    }catch (e) {
                                        console.log(e);
                                    }
                                    _this.loginForm.subBtnDisabled = false;
                                    _this.loginForm.subBtnText = '登录成功!';
                                    window.location.reload();
                                }else {
                                    _this.loginForm.subBtnDisabled = false;
                                    _this.loginForm.subBtnText = '登录';
                                    userRecode({behaviorType: '登录', behaviorResult: '登录失败'});
                                    msg.toast(data.msg);
                                }
                            },function () {
                                _this.loginForm.subBtnDisabled = false;
                                _this.loginForm.subBtnText = '登录';
                                userRecode({behaviorType: '登录', behaviorResult: '登录失败'});
                            }
                        )
                    },

                    // 验证程序
                    verify: function (itemObj) {
                        var flag = true;
                        if (itemObj.isRequired && itemObj.value === '') {
                            itemObj.isShowError = true;
                            itemObj.errorText = itemObj.errorTextEmpty ? itemObj.errorTextEmpty : '请输入' + itemObj.lebal;
                            flag = false;
                            return flag;
                        }
                        if (itemObj.reg && itemObj.value) {
                            itemObj.isShowError = !itemObj.reg.test(itemObj.value);
                            if (itemObj.isShowError) {
                                itemObj.isShowError = true;
                                itemObj.errorText = itemObj.errorTextContent ? itemObj.errorTextContent : '您输入的' + itemObj.lebal + '错误';
                                flag = false;
                            }
                        }
                        if (flag) {
                            itemObj.isShowError = false;
                            itemObj.errorText = '';
                        }
                        return flag;
                    },

                    //验证表单
                    verifyForm: function () {
                        var flag = true;
                        for (var item in this.form.formList) {
                            var itemObj = this.form.formList[item];
                            if(this.verify(itemObj) === false){
                                flag = false;
                            }
                        }
                        return flag;
                    },
                    // 登录弹框内的关闭按钮
                    close: function () {
                        dialogObj.hideDialog();
                    },

                    // 去注册
                    gotoReg: function () {
                        this.close();
                        setTimeout(function () {
                            meetingRegistEasyDialog.showDialog();
                        },500);
                    },

                    // 忘记密码
                    gotoForget: function () {
                        common.gotoForget('blank');
                    }

                },
                watch: {}
            }
        )
    },
    showDialog: function () {
        if (!this.vueObject) {
            this.vueExp();
        }
        this.dialogBoxDom.style.display = 'block';
        this.maskDom.classList.remove('dialog-mask-ani-fade-out');
        this.maskDom.classList.add('dialog-mask-ani-fade-in');

        this.dialogDom = document.querySelector('#regist-login-dialog').querySelector('.container');
        this.dialogDom.classList.remove('tr-dialog-ani-to-top');
        this.dialogDom.classList.add('tr-dialog-ani-from-top');

        /*gioTrackAction.gio_base('individualRegisterClick',{
            'individualRegisterEntrancePageTitle': document.title,
            'individualRegisterEntrancePageURL': window.location.href
        })*/
        //禁止后方滚动
        setScroll.unScroll();
    },
    hideDialog: function () {
        this.maskDom.classList.remove('dialog-mask-ani-fade-in');
        this.maskDom.classList.add('dialog-mask-ani-fade-out');

        this.dialogDom.classList.remove('tr-dialog-ani-from-top');
        this.dialogDom.classList.add('tr-dialog-ani-to-top');

        var _this = this;
        setTimeout(function () {
            _this.dialogBoxDom.style.display = 'none';
        }, 200);

        //允许后方滚动
        setScroll.removeUnScroll();

    },
    showLoading: function () {
        document.querySelector('.login-dialog-loading').style.display = 'block';
        //禁止后方滚动
        setScroll.unScroll();
    },
    hideLoading: function () {
        document.querySelector('.login-dialog-loading').style.display = 'none';
        //允许后方滚动
        setScroll.removeUnScroll();
    },

    init: function () {
    }
};
